import React from 'react';
import { Mountain, Waves } from 'lucide-react';

export const Logo = ({ size = 'md', showText = true }) => {
  const dim = size === 'lg' ? 'h-16 w-16' : size === 'sm' ? 'h-8 w-8' : 'h-10 w-10';
  const txt = size === 'lg' ? 'text-2xl' : size === 'sm' ? 'text-sm' : 'text-base';
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div className={`relative ${dim} iridescent-border flex items-center justify-center bg-black/80`}>
        <div className="absolute inset-[3px] flex flex-col items-center justify-center">
          <Mountain className="h-1/2 w-1/2 text-white" strokeWidth={1.5} />
          <Waves className="h-1/3 w-1/3 text-plai-teal -mt-1" strokeWidth={1.5} />
        </div>
      </div>
      {showText && (
        <div className="leading-tight">
          <div className={`font-headings tracking-tight uppercase ${txt} text-white`}>Public Landowner AI<sup className="text-[0.5em] ml-0.5">TM</sup></div>
          <div className="font-body text-[10px] tracking-[0.25em] uppercase text-white/50">GO OUTDOORS LLC<sup>TM</sup></div>
        </div>
      )}
    </div>
  );
};

export default Logo;
